<mat-tab-group mat-align-tabs="center">
  <mat-tab
    label="Habilitados ({{ itemsCoreData.type == 1 ? itemsCoreData.activeItems[0].detail.length : itemsCoreData.activeItems.length }})">
    <div class="w-100 mt-4" *ngFor="let benefit of itemsCoreData.activeItems">
      <div class="vs-section-content has-outline-menu sectionMaster" *ngIf="benefit['section']">
        <div class="vs-crud-menu">
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" *ngIf="benefit['sectionStatus'] === 'Activo'"
                  matTooltip="Editar sección"
                  (click)="sendSectionEdit(benefit)">
            <mat-icon>edit</mat-icon>
          </button>
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                  [matTooltip]="benefit['sectionStatus'] === 'Activo' ? 'Ocultar sección' : 'Mostrar sección'"
                  (click)="sendSectionAvailability(benefit['sectionId'])">
            <mat-icon>{{ benefit['sectionStatus'] === 'Activo' ? 'visibility_off' : 'visibility_on'}}</mat-icon>
          </button>
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                  matTooltip="Eliminar sección"
                  (click)="sendSectionDelete(benefit)">
            <mat-icon>delete_forever</mat-icon>
          </button>
        </div>
        <div class="content">
          <h2 class="vs-text-purple">{{benefit['section']}}</h2>
        </div>
      </div>
      <div class="vs-section-content mt-3 slides-edit sm">
        <div class="vs-outline-editCard">
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" (click)="sendItemCreate(benefit)" matTooltip="Añadir item">
            <mat-icon>add_circle</mat-icon>
          </button>
        </div>
        <perfect-scrollbar class="slides-scrollbar"
                           [config]="{useBothWheelAxes: true, suppressScrollX: false, suppressScrollY: false}">
          <div class="slides-content">
            <div class="vs-benefitCard has-outline-menu" *ngFor="let benefitItem of benefit['detail']"
                 [class.disabled-vs-content]="benefitItem['status'] === 'Desactivado'">
              <span class="overdue" *ngIf="convertToDate(benefitItem['dateFinish']) < currentDate"> Vencido</span>
              <img class="img-brand" [src]="benefitItem['imagenLogo']" alt="brand-logo"
                   *ngIf="benefitItem['imagenLogo']"
                   onerror="this.onerror= null; this.src = 'assets/images/img-placeholder.png'">
              <div class="img-description">
                <img [src]="benefitItem['imagen'] || benefitItem['logoModal'] || benefitItem['img']"
                     onerror="this.onerror= null; this.src = 'assets/images/img-placeholder.png'"
                     [alt]="'detail'">
              </div>
<!--              <p>{{benefitItem.dateFinish}}</p>-->
              <p><strong>{{benefitItem['discountMont']}}</strong> {{benefitItem['discountText'] || benefitItem['name']}}
              </p>
              <div class="vs-crud-menu">
                <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" *ngIf="benefitItem['status'] === 'Activo'"
                        matTooltip="Editar item"
                        (click)="sendItemEdit(benefitItem)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                        [matTooltip]="benefitItem['status'] === 'Activo' ? 'Ocultar item' : 'Mostrar item'"
                        (click)="sendItemAvailability(benefitItem['id'], benefit['sectionId'], benefitItem['name'])">
                  <mat-icon>{{ benefitItem['status'] === 'Activo' ? 'visibility_off' : 'visibility_on'}}</mat-icon>
                </button>
                <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                        matTooltip="Eliminar item"
                        (click)="sendItemDelete(benefitItem['id'], benefit['sectionId'], benefitItem['name'] || benefitItem['discountText'])">
                  <mat-icon>delete_forever</mat-icon>
                </button>
                <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" *ngIf="isBenefit"
                        matTooltip="Insertar PDF"
                        (click)="insertBenefitPdf(benefitItem['id'])">
                  <mat-icon>insert_drive_file</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
    <div class="w-100 text-center" *ngIf="!itemsCoreData.activeItems.length">
      <h2 class="mb-4 mt-5">No existen datos habilitados</h2>
    </div>
  </mat-tab>
  <mat-tab
    label="Deshabilitados ({{ itemsCoreData.type == 1 ? itemsCoreData.noActiveItems[0].detail.length : itemsCoreData.noActiveItems.length }})">
    <div class="w-100 mt-4" *ngFor="let benefit of itemsCoreData.noActiveItems">
      <div class="vs-section-content has-outline-menu sectionMaster disabled-vs-content" *ngIf="benefit['section']">
        <div class="vs-crud-menu">
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                  [matTooltip]="benefit['sectionStatus'] === 'Activo' ? 'Ocultar sección' : 'Mostrar sección'"
                  (click)="sendSectionAvailability(benefit['sectionId'])">
            <mat-icon>{{ benefit['sectionStatus'] === 'Activo' ? 'visibility_off' : 'visibility_on'}}</mat-icon>
          </button>
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                  matTooltip="Eliminar sección"
                  (click)="sendSectionDelete(benefit)">
            <mat-icon>delete_forever</mat-icon>
          </button>
        </div>
        <div class="content">
          <h2 class="vs-text-purple">{{benefit['section']}}</h2>
        </div>
      </div>
      <div class="vs-section-content mt-3 slides-edit sm">
        <div class="vs-outline-editCard disabled-vs-content">
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'">
            <mat-icon>block</mat-icon>
          </button>
        </div>
        <perfect-scrollbar class="slides-scrollbar"
                           [config]="{useBothWheelAxes: true, suppressScrollX: false, suppressScrollY: false}">
          <div class="slides-content">
            <div class="vs-benefitCard has-outline-menu disabled-vs-content"
                 *ngFor="let benefitItem of benefit['detail']">
              <img class="img-brand" [src]="benefitItem['imagenLogo']" alt="brand-logo"
                   *ngIf="benefitItem['imagenLogo']"
                   onerror="this.onerror= null; this.src = 'assets/images/img-placeholder.png'">
              <div class="img-description">
                <img [src]="benefitItem['imagen'] || benefitItem['logoModal'] || benefitItem['img']"
                     onerror="this.onerror= null; this.src = 'assets/images/img-placeholder.png'"
                     [alt]="'detail'">
              </div>
              <p>{{benefitItem.dateFinish}}</p>
              <p><strong>{{benefitItem['discountMont']}}</strong> {{benefitItem['discountText'] || benefitItem['name']}}
              </p>

              <div class="vs-crud-menu">
                <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                        [matTooltip]="benefitItem['status'] === 'Activo' ? 'Ocultar item' : 'Mostrar item'"
                        (click)="sendItemAvailability(benefitItem['id'], benefit['sectionId'], benefitItem['name'])">
                  <mat-icon>{{ benefitItem['status'] === 'Activo' ? 'visibility_off' : 'visibility_on'}}</mat-icon>
                </button>
                <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                        matTooltip="Eliminar item"
                        (click)="sendItemDelete(benefitItem['id'], benefit['sectionId'], benefitItem['name'])">
                  <mat-icon>delete_forever</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
    <div class="w-100 text-center" *ngIf="!itemsCoreData.noActiveItems.length">
      <h2 class="mb-4 mt-5">No existen datos deshabilitados</h2>
    </div>
  </mat-tab>
</mat-tab-group>
